export const FEATURE_FLAGS = [
  {
    key: 'PUBLIC_PRIVATE_OVERRIDE' as const,
    desc: 'Show control to override public/private on incident locations'
  },
  {
    key: 'ENABLE_RESPONDER_STATUS' as const,
    desc: 'Enable Pro Responders the ability to set response status for incidents'
  },
]satisfies readonly { key: string, desc: string }[]
